import dateHelpers from "./DateHelper";
import categoryHelpers from "./CategotyHelper";
import paymentTypeHelpers from "./PaymentTypeHelper";
import constants from "../shared/constants";
import businessHelper from "./BusinessHelper";

const resourceHelper = {

    emptyTeacher: function () {
        return {name: "", email: "", phone: "", public: false, note: ""}
    },

    emptyIncome: function () {
        return {title: "", price: 0, qty: 1, category: categoryHelpers.notDefined().value, pt: paymentTypeHelpers.notDefined().value, date: dateHelpers.databaseDate(new Date())}
    },

    emptyRoom: function () {
        return {name: "", capacity: "", is_main: false, note: ""}
    },

    emptyClassType: function () {
        return {name: "", duration: 60, description: "", rules: null, students: null, is_free: false,
            is_workshop: false, clr: null, public: true, ticket_types: []}
    },

    emptyTicketType: function () {
        return {name: "", duration: 7, units: "d", price: 0.00, start_first_day: true, classes_left: 10,
            is_workshop: false, whitelisted: true, renewable: null, limit: "", target_classes: [], starts_on_use: false}
    },

    emptyPromoCode: function () {
        return {id: null, code: "", discount_perc: "", groups: []}
    },

    emptyRule: function () {
        return {time: "10:00", teachers: undefined, rooms: undefined, regularity: "1,2,3,4", days: "0,1,2,3,4", link: "", is_online: false}
    },

    emptyRank: function () {
        return {title: "", icon: "star", position: 0, color: "3E7DB5"}
    },

    emptyReward: function () {
        return {title: "", icon: "", reward_rules: []}
    },

    emptyLocale: function () {
        return {
            title: "",
            description: "",
            street: "",
            city: "",
            country: "",
            zipcode: "",
        }
    },

    emptyAd: function () {
        return {title: "", photo: "", description: "", date: "", expires: "", link: "", end_date: "", class_type_id: null}
    },

    emptyBdSettings: function () {
        return {
            to_active: false,
            to_all: false,
            active_text: "",
            inactive_text: "",
        }
    },

    emptyClassReminderSettings: function () {
        return {
            is_enabled: false,
        }
    },

    emptyClassRegistrationSettings: function () {
        return {
            is_enabled: false,
        }
    },

    emptyExpTicketsSettings: function () {
        return {
            is_enabled: false,
        }
    },

    emptyWelcomeSettings: function () {
        return {
            is_enabled: false,
            active_text: null,
        }
    },

    emptyEvent: function () {
        return {title: "", body: "", time: dateHelpers.databaseDateTime(new Date()), admin_only: false, event_type: constants.events.event, remind: false}
    },

    emptyProduct: function () {
        return {title: "", description: "", destinationEmail: "", isGiftCard: false, emailText: "", ttId: null, price: 0}
    },

    emptyInvoice: function () {
        return {invoice_item: {title: "", qty: 1, price: "0.00"}, number: businessHelper.business().i_number || "", prefix: businessHelper.business().i_prefix || "", pt : "n", client_name: "", client_id: "", client_address: "", ticket_id: null, income_id: null, date: dateHelpers.databaseDate(new Date())}
    },

    emptyReminder: function () {
        return {title: "", body: "", time: dateHelpers.databaseDateTime(new Date()), admin_only: false, event_type: constants.events.reminder, remind: false}
    },

    emptyClassPlan: function () {
        return {title: "", class_plan_items: []}
    },

    classTemplateFromClassType(date, classType) {
        return {
            name: classType.name,
            date: date ? dateHelpers.databaseDate(date) : dateHelpers.databaseDate(new Date()),
            start: "12:00",
            end: "13:00",
            is_workshop: classType.is_workshop,
            is_free: classType.is_free,
            class_type_id: classType.id
        }
    },

    classTypeIsValidForTicket(ticketType, classTypeId) {
        if (classTypeId && ticketType.target_classes && ticketType.target_classes.length > 0) {
            const cl = ticketType.target_classes.map(it => it.id);
            return cl.includes(classTypeId) == true
        }
        else return true
    },

    ticketTypeIsValidForClassType(classType, ticketTypeId) {
        if (ticketTypeId && classType && classType.ticket_types && classType.ticket_types.length > 0) {
            const acceptedTicketIds = classType.ticket_types.map(it => it.id);
            return acceptedTicketIds.includes(ticketTypeId) == true
        }
        else return true
    }
};

export default resourceHelper;